import { Directive } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingBetweenTableAndPaging]',
    standalone: false
})
export class ListingBetweenTableAndPagingDirective extends TemplateRefDirective {

}
